import createItemFetcher from "../helpers/item";
import { createUseFetch, createUseItem } from "../helpers/fetchHooks";
import { createActionDuck } from "../helpers/action";
import { createPendingValue } from "./PendingValues";
import { createNotificationOnCreateEpic, createNotificationOnCreateErrorEpic, registerIncorrectValue, registerFinishedValue, } from "./updateNotification";
import { Observable } from "rxjs/Observable";
import { combineDucks } from "../helpers/combineDucks";
const computeSettingsId = () => {
    return `copyDataset`;
};
export const getApiRoute = () => {
    return `/api/v1/copyDataset/`;
};
export const copyDatasetGetSettings = createItemFetcher(getApiRoute, "COPY_DATASET_SETTINGS_GET", computeSettingsId);
export const createCopyDatasetGetSettings = () => copyDatasetGetSettings;
export const postApiRoute = () => {
    const url = `/api/v1/copyDataset/`;
    return {
        method: "POST",
        url,
    };
};
export const copyDatasetPostSettings = createActionDuck("COPY_DATASET_SETTINGS_POST", postApiRoute, computeSettingsId);
export const useCopyDatasetSettings = createUseFetch(copyDatasetGetSettings, (state) => state.copyDataset.settings);
export const getCopyDatasetSettings = createUseItem(copyDatasetGetSettings, (state) => state.copyDataset.settings);
export const getApiFilesRoute = () => {
    return `/api/v1/copyDataset/files`;
};
export const copyDatasetFiles = createItemFetcher(getApiFilesRoute, "COPY_DATASET_FILES_GET", computeSettingsId);
export const createCopyDatasetGetFiles = () => copyDatasetFiles;
export const postApiFilesRoute = ({ scenario, workspace }) => {
    const url = `/api/v1/copyDataset/${scenario}/${workspace}`;
    return {
        method: "POST",
        url,
    };
};
export const copyDatasetPostFiles = createActionDuck("COPY_DATASET_FILES_POST", postApiFilesRoute, computeSettingsId);
export const useCopyDatasetFiles = createUseFetch(copyDatasetFiles, (state) => state.copyDataset.files);
export const getCopyDatasetFiles = createUseItem(copyDatasetFiles, (state) => state.copyDataset.files);
function updateSettingsOnUpdate(ActionKeys) {
    return (actions$) => actions$
        .ofType(ActionKeys.FINISH)
        .mergeMap(() => Observable.of(copyDatasetGetSettings.actions.fetchItem()));
}
copyDatasetPostSettings.middleware.push(createNotificationOnCreateEpic(copyDatasetPostSettings.ActionKeys), createNotificationOnCreateErrorEpic(copyDatasetPostSettings.ActionKeys), updateSettingsOnUpdate(copyDatasetPostSettings.ActionKeys));
copyDatasetPostFiles.middleware.push(registerIncorrectValue(copyDatasetPostFiles.ActionKeys), registerFinishedValue(copyDatasetPostFiles.ActionKeys));
export const postSettings = (data) => copyDatasetPostSettings.actions.start({}, data);
export const postFiles = (config, data) => copyDatasetPostFiles.actions.start(config, data);
const pendingValues = createPendingValue();
export const startCopy = (data) => pendingValues.actions.start(data);
export const copyDataset = combineDucks({
    settings: copyDatasetGetSettings,
    postSettingsInfo: copyDatasetPostSettings,
    files: copyDatasetFiles,
    postFilesInfo: copyDatasetPostFiles,
    pendingValues,
});
//# sourceMappingURL=index.js.map